import {
  CheckNotes,
  InspectionCase,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';

export class WaterReservoirInstallationDto extends InspectionCase {
  totalInstalledWaterReservoirs?: InspectionCase;
  waterReservoirVolumeAsDesigned?: InspectionWaterSupplyDataCaseDto;
  reservoirMaterialType?: InspectionCase;
  installedVortexPlate?: InspectionCase;
  installedSurfingAndEmptyingPipes?: InspectionCase;
  installedAccessHoleAndladder?: InspectionCase;
  installedWaterRreservoirAltimeter?: InspectionCase;
  isWaterReservoirFull?: InspectionCase;
}

export class WaterReservoirInstallation extends WaterReservoirInstallationDto {
  constructor(
    data: WaterReservoirInstallationDto = { title: 'התקנת מאגר מים' }
  ) {
    super(data);
    this.totalInstalledWaterReservoirs = new InspectionCase({
      ...data.totalInstalledWaterReservoirs,
      title: `ציין את מספר מאגרי המים שהותקנו`
    });
    this.waterReservoirVolumeAsDesigned = new InspectionWaterSupplyDataCase({
      ...data.waterReservoirVolumeAsDesigned,
      title: `נפח מאגר המים תואם לתכניות שאושרו?`
    });
    this.reservoirMaterialType = new InspectionCase({
      ...data.reservoirMaterialType,
      title: `ציין את סוג החומר ממנו עשויי מאגר המים`
    });
    this.installedVortexPlate = new InspectionCase({
      ...data.installedVortexPlate,
      title: `האם הותקנה פלטת וורטקס בקו היניקה בתוך המאגר`
    });
    this.installedSurfingAndEmptyingPipes = new InspectionCase({
      ...data.installedSurfingAndEmptyingPipes,
      title: `האם הותקנו צינורות גלישה וריקון בהתאם לדרישות התקן והתכנון`
    });
    this.installedAccessHoleAndladder = new InspectionCase({
      ...data.installedAccessHoleAndladder,
      title: `האם הותקן פתח גישה וסולם עליה למאגר`
    });
    this.installedWaterRreservoirAltimeter = new InspectionCase({
      ...data.installedWaterRreservoirAltimeter,
      title: `האם הותקן מד גובה מאגר מים`
    });
    this.isWaterReservoirFull = new InspectionCase({
      ...data.isWaterReservoirFull,
      title: `ציין האם מאגר המים מלא`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.totalInstalledWaterReservoirs.isApplicable ||
        this.totalInstalledWaterReservoirs.isPassed) &&
        (!this.waterReservoirVolumeAsDesigned.isApplicable ||
          this.waterReservoirVolumeAsDesigned.isPassed) &&
        (!this.reservoirMaterialType.isApplicable ||
          this.reservoirMaterialType.isPassed) &&
        (!this.installedVortexPlate.isApplicable ||
          this.installedVortexPlate.isPassed) &&
        (!this.installedSurfingAndEmptyingPipes.isApplicable ||
          this.installedSurfingAndEmptyingPipes.isPassed) &&
        (!this.installedAccessHoleAndladder.isApplicable ||
          this.installedAccessHoleAndladder.isPassed) &&
        (!this.installedWaterRreservoirAltimeter.isApplicable ||
          this.installedWaterRreservoirAltimeter.isPassed) &&
        (!this.isWaterReservoirFull.isApplicable ||
          this.isWaterReservoirFull.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.totalInstalledWaterReservoirs.getNotes(),
      ...this.waterReservoirVolumeAsDesigned.getNotes(),
      ...this.reservoirMaterialType.getNotes(),
      ...this.installedVortexPlate.getNotes(),
      ...this.installedSurfingAndEmptyingPipes.getNotes(),
      ...this.installedAccessHoleAndladder.getNotes(),
      ...this.installedWaterRreservoirAltimeter.getNotes(),
      ...this.isWaterReservoirFull.getNotes()
    ];
  }
}
